import ReactDOM from 'react-dom';
import {
  Dispatch, SetStateAction, useRef, useState
} from 'react';
import { useOutside } from 'hooks/UseOutside';

import SendDocumentationImg from '../../../../assets/img/send-documentation.png'

import {
  ModalCloseButton, ModalContainer, ModalOkButton, ModalParagraph, ModalSection, ModalTitle
} from './_sendDocumentsModal';

interface ISendDocumentsProps {
  toggleModal: Dispatch<SetStateAction<boolean>>;
  callback?: () => void;
}

export const SendDocuments = ({
  toggleModal, callback
}: ISendDocumentsProps) => {
  const modalRoot = document.getElementById('root-modal');
  const modalRef = useRef(null);

  const [hideModal, setHideModal] = useState(false);
  const callbackHandler = {} as { setCallback: boolean };

  const handleContinueCallback = () => {
    callbackHandler.setCallback = true

    handleCloseModal()
  }

  const handleCloseModal = () => {
    setHideModal((prevState) => !prevState);

    setTimeout(() => {
      toggleModal((prevState) => !prevState);

      if(callback && callbackHandler?.setCallback) {
        callback()
      }
    }, 500);
  }

  useOutside(modalRef, handleCloseModal);

  if(!modalRoot) {
    return null;
  }

  return ReactDOM.createPortal(
    <ModalSection className={`${hideModal ? 'modal-send-documents--hide' : ''}`}>
      <ModalContainer ref={modalRef}>
        <ModalCloseButton
          type="button"
          onClick={handleCloseModal}
        >
          X
        </ ModalCloseButton>
        <ModalTitle>
          Envie a sua documentação
        </ModalTitle>
        <ModalParagraph>
          Para receber os chamados de
          atendimento é necessário enviar
          sua documentação atualizada.
        </ModalParagraph>
        <img
          src={SendDocumentationImg}
          alt="send documents"
        />
        <ModalOkButton
          type="button"
          onClick={handleContinueCallback}
        >
          Entendi
        </ModalOkButton>
      </ModalContainer>
    </ModalSection>,
    modalRoot
  )
}
